import { render, staticRenderFns } from "./SubfamilyList.vue?vue&type=template&id=428fd028&lang=pug&"
import script from "./SubfamilyList.vue?vue&type=script&lang=js&"
export * from "./SubfamilyList.vue?vue&type=script&lang=js&"
import style0 from "./SubfamilyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubfamilyList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VFlex,
  VForm,
  VLayout,
  VSpacer,
  VSwitch,
  VTextField,
  VToolbar,
})
